<div class="container-fluid su-top-content-wrapper">
  <div class="logo-app">
    <img src="../../../../../assets/themepuro/img/logo-app.svg" alt="logo app">
    <h1 class="text-light text-museo">Lorem ipsum dolor sit amet, consectetuer adipiscing elit</h1>
  </div>
</div>